import * as React from "react";

import { PATHS, ROUTES } from "@config/app.routing";

import { ORIGIN } from "@typings/globals";

import { FooterDataWrapper as FooterDataWrapperOrganism } from "@ui/Organisms/FooterDataWrapper";

import { resolveCountryFromUrl } from "@services/ResolveCountryFromUrl";
import { createHref } from "@services/CreateHref";

import { useTelemetry } from "@hooks/useTelemetry";
import { useLocalisation } from "@hooks/useLocalisation";
import { useFeatureToggle } from "@hooks/useFeatureToggle";
import { useTranslate } from "@hooks/useTranslate";

interface Props {
  isTeaserVersion?: boolean;
}

const FooterContainer = (props: Props): React.ReactElement => {
  const { elementClick } = useTelemetry();
  const { country, language } = useLocalisation();
  const translate = useTranslate();

  const isGiftCardsEnabled = useFeatureToggle("gift_cards");
  const giftCardsLink = `${createHref(language, PATHS.CLIENT_APP)}#${
    ROUTES.GIFT_CARDS
  }`;

  return (
    <FooterDataWrapperOrganism
      variant={ORIGIN.BATMAID}
      language={language}
      country={country || resolveCountryFromUrl()}
      giftCardsUrl={isGiftCardsEnabled ? giftCardsLink : undefined}
      giftCardsLabel={
        isGiftCardsEnabled
          ? translate("batmaid_pwa_navigation.gift_cards")
          : undefined
      }
      isStandalone={false}
      isTeaserVersion={props.isTeaserVersion}
      onPhoneClick={() =>
        elementClick("give_call_footer", { buttonId: "give_call_footer" })
      }
      onEmailClick={() =>
        elementClick("send_email_footer", { buttonId: "send_email_footer" })
      }
    />
  );
};

export { FooterContainer };
